import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, Phone } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const nav = [
  { to: "/", label: "Home" },
  { to: "/metodo", label: "Il Metodo" },
  { to: "/casi", label: "Casi di Successo" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/contatti", label: "Contatti" },
  { to: "/blog", label: "Blog" },
  { to: "/prenota", label: "Prenota" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const loc = useLocation();

  return (
    <header className="glass fixed top-0 left-0 right-0 z-50" data-testid="site-header">
      <div className="container-editorial flex items-center justify-between py-3 md:py-3.5 min-h-[72px] md:min-h-[80px]">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link">
          <img src="/logo-header.png" alt="Sdebitiamoci Srl" fetchPriority="high" className="h-12 md:h-14 w-auto"/>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {nav.map(n => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s+/g,'-')}`}
              className={({ isActive }) =>
                `text-sm tracking-wide link-underline pb-0.5 ${isActive ? "text-[#2d6fc4]" : "text-[#333333] hover:text-[#2d6fc4]"}`
              }
              end={n.to === "/"}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          {user && user !== false ? (
            <>
              <Link to="/dashboard" data-testid="header-dashboard-btn" className="text-sm tracking-wide text-[#2d6fc4] hover:text-[#2d6fc4]">
                Area Clienti
              </Link>
              <Link to="/documenti" data-testid="header-documents-btn" className="text-sm tracking-wide text-[#2d6fc4] hover:text-[#2d6fc4]">
                Documenti
              </Link>
            </>
          ) : (
            <Link to="/login" data-testid="header-login-btn" className="text-sm tracking-wide text-[#2d6fc4] hover:text-[#2d6fc4]">
              Accedi
            </Link>
          )}
          <a
            href="tel:+393927715932"
            data-testid="header-call-btn"
            className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg text-sm font-semibold tracking-wide text-white bg-[#16A34A] hover:bg-[#15803D]"
            style={{ transition: "background-color 200ms ease" }}
          >
            <Phone size={15}/> Chiama ora
          </a>
          <Link
            to="/contatti"
            data-testid="header-cta-btn"
            className="btn-terracotta inline-flex items-center px-5 py-2.5 rounded-lg text-sm tracking-wide"
          >
            Consulenza gratuita
          </Link>
        </div>

        <div className="md:hidden flex items-center gap-1">
          <a
            href="tel:+393927715932"
            data-testid="header-call-btn-mobile"
            aria-label="Chiama ora"
            className="inline-flex items-center justify-center h-10 w-10 rounded-full text-white bg-[#16A34A]"
          >
            <Phone size={17}/>
          </a>
          <button
            className="p-2 rounded-md text-[#2d6fc4]"
            onClick={() => setOpen(v => !v)}
            data-testid="mobile-menu-toggle"
            aria-label="Menu"
          >
            {open ? <X size={22}/> : <Menu size={22}/>}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.3 }}
            className="md:hidden border-t border-[#E5E7EB] bg-[#FFFFFF]/95 backdrop-blur-xl"
          >
            <div className="container-editorial py-6 flex flex-col gap-4">
              {nav.map(n => (
                <NavLink
                  key={n.to}
                  to={n.to}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) => `text-lg font-serif ${isActive ? "text-[#2d6fc4]" : "text-[#2d6fc4]"}`}
                  end={n.to === "/"}
                >
                  {n.label}
                </NavLink>
              ))}
              {user && user !== false ? (
                <Link to="/dashboard" onClick={()=>setOpen(false)} className="text-lg font-serif">Area Clienti</Link>
              ) : (
                <Link to="/login" onClick={()=>setOpen(false)} className="text-lg font-serif">Accedi</Link>
              )}
              <a href="tel:+393927715932" onClick={()=>setOpen(false)} data-testid="menu-call-btn"
                className="inline-flex justify-center items-center gap-2 px-5 py-3 rounded-lg text-sm font-semibold text-white bg-[#16A34A] mt-2">
                <Phone size={15}/> Chiama ora — 392 771 5932
              </a>
              <Link to="/contatti" onClick={()=>setOpen(false)} className="btn-terracotta inline-flex justify-center px-5 py-3 rounded-lg text-sm">
                Consulenza gratuita
              </Link>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </header>
  );
}
